import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "autosizingtypeenum"
    }}>{`AutoSizingTypeEnum`}</h1>
    <p>{`Auto sizing type options for text.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OFF`}</strong>{` = 1330005536`}</p>
      <p parentName="blockquote">{`Text frame auto-sizing is off.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HEIGHT_ONLY`}</strong>{` = 1751476583`}</p>
      <p parentName="blockquote">{`Text frame will be resized in height dimension only.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WIDTH_ONLY`}</strong>{` = 2003395700`}</p>
      <p parentName="blockquote">{`Text frame will be resized in width dimension only.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HEIGHT_AND_WIDTH`}</strong>{` = 1752069993`}</p>
      <p parentName="blockquote">{`Text frame will be resized in both(height and width) dimensions.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HEIGHT_AND_WIDTH_PROPORTIONALLY`}</strong>{` = 1752070000`}</p>
      <p parentName="blockquote">{`Text frame will be resized in both(height and width) dimensions proportionally.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      